import { render, staticRenderFns } from "./shopPayment.vue?vue&type=template&id=0aee01b7&scoped=true&"
import script from "./shopPayment.vue?vue&type=script&lang=js&"
export * from "./shopPayment.vue?vue&type=script&lang=js&"
import style0 from "./shopPayment.vue?vue&type=style&index=0&id=0aee01b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aee01b7",
  null
  
)

export default component.exports